import { useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "../../authPatient/redux/thunks/authThunks";
import useEffectiveUserContext from "../../sous-profile/hooks/useEffectiveUserContext";

let currentUserRestoreRequest = null;

/**
 * useAuthSession
 * - auto=false by default (no call on mount)
 * - once=true prevents double-dispatch in React 18 StrictMode
 */
export default function useAuthSession({ auto = false, once = true } = {}) {
  const dispatch = useDispatch();
  const auth = useSelector((s) => s.auth);
  const effectiveUserContext = useEffectiveUserContext();
  const ranRef = useRef(false);

  const refresh = useCallback(() => dispatch(getCurrentUser()), [dispatch]);

  useEffect(() => {
    if (!auto) return;
    if (auth?.user || auth?.isLoading || auth?.isError) return;
    if (once && ranRef.current) return; // guard StrictMode
    ranRef.current = true;
    if (!currentUserRestoreRequest) {
      const request = dispatch(getCurrentUser());
      currentUserRestoreRequest = request;
      Promise.resolve(request)
        .finally(() => {
          if (currentUserRestoreRequest === request) {
            currentUserRestoreRequest = null;
          }
        })
        .catch(() => {});
    }
  }, [auto, once, dispatch, auth?.user, auth?.isLoading, auth?.isError]);

  return { auth, refresh, ...effectiveUserContext };
}
